export default __webpack_public_path__ + "static/media/BB_22.eba982a8.png";